import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M18 20a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a3 3 0 013-3h6a3 3 0 012.995 2.824L18 17v3zM8 9.999c0 1.116.456 2.125 1.192 2.85l.162.151H9a4 4 0 00-3.995 3.8L5 17H3a1 1 0 01-1-1v-3a3 3 0 013-3l3-.001zm8 0L19 10a3 3 0 013 3v3a1 1 0 01-1 1h-2a4 4 0 00-3.8-3.995L15 13h-.354A3.99 3.99 0 0016 10v-.001zM12 7a3 3 0 01.06 6l-.031-.001L12 13l-.03-.001-.088-.003-.058-.001h-.001l.147.005a3.049 3.049 0 01-.999-.181l-.028-.01a3.015 3.015 0 01-1.605-1.425 2.977 2.977 0 01-.207-.505l.04.12a2.978 2.978 0 01-.166-.824L9 10a3 3 0 013-3zM7 3a3 3 0 012.946 3.569A4 4 0 008.2 8.749 3 3 0 117 3zm10 0a3 3 0 11-1.201 5.75 4.001 4.001 0 00-1.744-2.182A3 3 0 0117 3z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
